<template>
    <v-menu 
        v-if="clipboardImage" 
        ref="menuClipboardImage" 
        v-model="menuClipboardImage"
        attach=".refMenuClipboardImage" 
        top 
        offset-y
        nudge-top="15"
        :close-on-click="false"
        :close-on-content-click="false"
        transition="slide-y-reverse-transition"
    >
        <v-card class="mx-auto nd-border overflow-hidden" width="350" elevation="12" :style="{ backgroundColor: $vuetify.theme.dark ? 'var(--v-gray100-base)' : 'white' }" >
            <div class="d-flex align-center justify-space-between px-3 py-2" >
                <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2">mdi-image-plus-outline</v-icon>
                    <span class="text-caption font-weight-bold text-uppercase" :class="$vuetify.theme.dark ? 'gray400--text' : 'gray700--text'">
                        Imagem colada
                    </span>
                </div>
                <v-btn icon x-small @click="$emit('clear-clipboard-image')">
                    <v-icon size="18">mdi-close</v-icon>
                </v-btn>
            </div>

            <div class="pa-2" :style="{ backgroundColor:'rgba(0,0,0,0.2)' }" >
                <v-img :src="clipboardImage" height="280" contain class="rounded" />
            </div>

            <v-card-actions class="pa-2">
                <ib-btn block small color="error" text @click="$emit('clear-clipboard-image')" :loading="isSendingClipboardImage" >
                    <v-icon left size="18">mdi-trash-can-outline</v-icon>
                    Remover imagem
                </ib-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    name: 'ClipboardImageMenu',
    props: {
        clipboardImage: {
            type: String,
            required: false,
        },
        isSendingClipboardImage: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            menuClipboardImage: true,
        };
    },
};
</script>